export const transformString = (input = "") => {
  return input
    ?.replace(/\bOne\b/g, "HR: Tier 1") // Replace all occurrences
    ?.replace(/\bTwo\b/g, "HR: Tier 2")
    ?.replace(/\bThree\b/g, "HR: Tier 3")
    ?.replace(/\s*-\s*None\b/g, ""); // Removes ' - None' properly
};
